import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface CarouselProps {
  onImageClick: () => void;
}
const images = ['https://cdn.magicpatterns.com/uploads/8yqdz16MvPLvVqFqdQtZgt/IMG_5037.png', 'https://cdn.magicpatterns.com/uploads/3AZbAa8DdkMMMoAcHrEqwB/IMG_5036.png', 'https://cdn.magicpatterns.com/uploads/mrW8Nzi5K9uQwXgdxddc46/IMG_5035.png'];
export function Carousel({
  onImageClick
}: CarouselProps) {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const paginate = (dir: number) => {
    setDirection(dir);
    setIndex(i => (i + dir + images.length) % images.length);
  };
  return <section className="w-full bg-gray-50 py-16 px-4" data-id="element-30">
      <div className="max-w-md mx-auto" data-id="element-31">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-32">
          👀 lo que te vas a encontrar dentro
        </h2>

        {/* Instagram-style card */}
        <div className="bg-white rounded-xl shadow-xl overflow-hidden border border-gray-200" data-id="element-33">
          {/* Header bar */}
          <div className="flex items-center gap-3 px-4 py-3 border-b border-gray-100" data-id="element-34">
            <div className="w-9 h-9 rounded-full bg-gradient-to-tr from-teal-500 to-teal-700 flex items-center justify-center text-white font-bold text-sm" data-id="element-35">
              AP
            </div>
            <div className="flex-1" data-id="element-36">
              <p className="text-sm font-semibold text-gray-900 leading-none" data-id="element-37">
                acompanante.pedagogico
              </p>
              <p className="text-xs text-gray-400 mt-0.5" data-id="element-38">Megapack</p>
            </div>
          </div>

          {/* Image */}
          <div className="relative aspect-square bg-gray-100 overflow-hidden cursor-pointer" onClick={onImageClick} data-id="element-39">
            <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-40">
              <motion.img key={index} src={images[index]} alt={`Vista previa ${index + 1}`} custom={direction} initial={{
              opacity: 0,
              x: direction >= 0 ? 80 : -80
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: direction >= 0 ? -80 : 80
            }} transition={{
              duration: 0.3
            }} className="absolute inset-0 w-full h-full object-cover" data-id="element-41" />
            </AnimatePresence>

            <button onClick={e => {
            e.stopPropagation();
            paginate(-1);
          }} aria-label="Anterior" className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 rounded-full p-1.5 shadow transition-colors" data-id="element-42">
              <ChevronLeft className="w-5 h-5" data-id="element-43" />
            </button>
            <button onClick={e => {
            e.stopPropagation();
            paginate(1);
          }} aria-label="Siguiente" className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 rounded-full p-1.5 shadow transition-colors" data-id="element-44">
              <ChevronRight className="w-5 h-5" data-id="element-45" />
            </button>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 py-4" data-id="element-46">
            {images.map((_, i) => <button key={i} onClick={() => {
            setDirection(i > index ? 1 : -1);
            setIndex(i);
          }} aria-label={`Ir a imagen ${i + 1}`} className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-teal-600' : 'w-2 bg-gray-300'}`} data-id="element-47" />)}
          </div>
        </div>
      </div>
    </section>;
}